import React from 'react';
import {
    ExamApplicationsTable,
    ExamApplicationsColumnHeader,
    ExamStatus,
    Card,
} from 'components';
import { IExamApplication } from 'components/models';
import styles from './ApplicantsTab.module.scss';

const ApplicantsTab = ({
    examApplications, handleApplicantsListChange, handleApplicantClick, examStatus, isExpert,
}: IProps) => {
    const applicationsHeader = [
        new ExamApplicationsColumnHeader('applicantFullName', 'ФАМИЛИЯ, ИМЯ, ОТЧЕСТВО'),
        new ExamApplicationsColumnHeader('applicantPhone', 'Телефон'),
        new ExamApplicationsColumnHeader('isExpert', 'Тип'),
        new ExamApplicationsColumnHeader('status', examStatus !== ExamStatus.Finished ? 'Статус' : 'Требуется'),
    ];

    const isExamFinished = React.useMemo(() => (
      examStatus === ExamStatus.Finishing
      || examStatus === ExamStatus.Finished
      || examStatus === ExamStatus.FinalizedResults
      || examStatus === ExamStatus.NokProtocolSigned
      || examStatus === ExamStatus.AkProtocolSigned
      || examStatus === ExamStatus.SovietProtocolSignedByMembers
      || examStatus === ExamStatus.SovietProtocolSignedByChairman
    ), [examStatus]);

    const title = React.useMemo(() => {
        if (isExpert) {
            if (examStatus === ExamStatus.ApplyingFinished) {
                return 'Допуск соискателей';
            } if (examStatus === ExamStatus.Finished) {
                return 'Обработка результатов';
            }

            return 'Список соискателей';
        }

        return 'Список соискателей';
    }, [isExpert, examStatus]);

    const category = React.useMemo(() => {
        if (isExpert) {
            return isExamFinished
                ? 'Необходимо написать рекомендации для соискателей, не сдавших экзамен и финализировать результат по практической части для остальных соискателей'
                : 'Перед началом экзамена необходимо проверить документы и осуществить допуск соискателей';
        }

        return 'Список соискателей';
    }, [isExpert, isExamFinished]);

    return (
        <Card
          title={title}
          category={category}
          categoryClassName={styles.categoryTitle}
          withoutPadding
          withoutBorder
        >
            <ExamApplicationsTable
              headers={applicationsHeader}
              examApplications={examApplications}
              examStatus={examStatus}
              onChange={handleApplicantsListChange}
              onItemClick={handleApplicantClick}
            />
        </Card>
    );
};

export default ApplicantsTab;

interface IProps extends IAppProps {
    examApplications: IExamApplication[];
    examStatus: ExamStatus;
    isExpert?: boolean;
}

export interface IAppProps {
    handleApplicantsListChange: (searchField?: string, searchTerm?: string, page?: number, pageSize?: number) => void;
    handleApplicantClick?: (examApplicationId: string) => void;
}
